import { AnyAction } from 'redux';

import { stationsActions } from '../reducer';

export const resetStationsPriceReportSettings = (): AnyAction => stationsActions.resetStationsPriceReportSettings();